import { OidFunction } from '@kollective-frontend/ksdk-api';
import maybeByteRanged from '../webrtc/agent/maybeByteRanged';
import vimeoObjectId from '../webrtc/agent/vimeoObjectId';
import stripQueryParams from '../common/utils/stripQueryParams';
import { IvsHlsOidMap } from './objectId/HlsObjectIdMapper';
import { safeSave } from '../util/storage';
import logger from '../log';

const log = logger.getLogger(__filename);

export type ObjectIdFunction = (
  url: string,
  opts: { headers: Map<string, string> }
) => string;

export const amazonIvs = (): OidFunction => {
  const mapper = new IvsHlsOidMap();
  // Setting the flag usesIvs so that we only monitor the media manifests
  // for players using IVS
  safeSave({ key: 'ksdk::usesIvs', log, data: true });
  return url => {
    const oid = mapper.getOid(url);
    if (oid) {
      return oid;
    } else {
      return stripQueryParams(url);
    }
  };
};

export function getObjectIdFunction(
  app: string,
  override?: OidFunction
): ObjectIdFunction {
  if (override) {
    return override;
  }
  // anything after a "|" is a NRT section or other app name modifier and
  // will be ignored.
  const appName = (app ?? '').replace(/\|.*/i, '');
  switch (appName) {
    case 'vimeo':
      return vimeoObjectId;
    case 'panopto':
    case 'keepeek.dam':
      return (url, opts) => maybeByteRanged(url, opts.headers);
    // TODO - SRV-3987 - Define the applications that will support IVS
    case 'brandlive.app':
    case 'cisco.webexevents':
    case 'cisco.webexstreaming':
    case 'cisco.webexwebinars':
    case 'kollective.kcaster':
    case 'voila.events':
    case 'webex.events':
      return amazonIvs();
    default:
      return stripQueryParams;
  }
}
